import { useQuery } from '@tanstack/react-query';

import { api } from '../api';
import type { FeedItem } from '../types';

export function useFeed(page: number) {
  return useQuery({
    queryKey: ['feed', page],
    queryFn: () => api.feed.list(page, 20),
  });
}

export function useRandom() {
  return useQuery<FeedItem | null>({
    queryKey: ['random'],
    queryFn: () => api.random.get(),
    retry: false,
  });
}